import React from 'react';
import {Avatar, Link, Sheet, Stack, Typography} from '@mui/joy';
import {ExperienceModel} from "../model/experience";
import {Launch} from "@mui/icons-material";

function Experience({experience, number}: { experience: ExperienceModel, number: number }) {
    const startDate = experience.startDate.substring(experience.startDate.indexOf('-') + 1).replaceAll('-','/');
    const endDate = (experience.endDate.indexOf('-') >= 0)
        ? experience.endDate.substring(experience.endDate.indexOf('-') + 1).replaceAll('-','/')
        : experience.endDate;
    return (
        <Sheet variant='soft' sx={{padding: 0, minWidth: 'xs'}}>
            <Link
                href={`/experience/${experience.title.concat('-' + experience.company.concat('-' + experience.startDate)).toLowerCase().replaceAll(' ', '-')}`}
                variant="plain" underline="none">
                <Stack direction='row' spacing={2} alignItems='start'>
                    <Avatar size='sm' variant='soft'>
                        <Launch/>
                    </Avatar>
                    <Stack alignContent="center" spacing={0} justifyContent="center" direction="column">
                        <Typography color="neutral"
                                    level='body-md'>{startDate} - {endDate}</Typography>
                        <Typography level="title-md" fontWeight='lg'> {experience.title}</Typography>
                        <Typography level='body-md'>{experience.company}</Typography>
                    </Stack>
                </Stack>
            </Link>
        </Sheet>
    );
}

export default Experience;